import { useContext, useState, useEffect } from 'react';
import { NavLink, Link }                   from 'react-router-dom';
import { Menu, Icon, Dropdown }            from 'semantic-ui-react';
import { getAPI }                          from '../libs/fetchAPI';
import styled                              from 'styled-components';
import AppContext                          from '../context/HeaderContext';

const menu_css = {
	display: "flex",
	background: "#f2f3f3",
};

const CustomIcon = styled(Icon)`
	margin-right: 10px !important;
`;

const CustomDiv = styled.div`
	display: flex;
	flex-direction: column;
	height: 100vh;
`;

const TopMenu = styled(Menu)`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

const BottomMenuItems = styled.div`
	margin-top: auto;
	margin-bottom: 15px;
`;

const CustomLink = styled(Link)`
	color: rgba(0,0,0,.87) !important;
`;

function SideBar() {
	const {
		current_organization_id,
		current_project_id,
		updateOrganizationId,
		updateProjectId,
		clearLocalStorage,
		user,
		 } = useContext(AppContext);

	const [ organization_options, setOrganizationOptions ] = useState([]);
	const [ project_options, setProjectOptions ]           = useState([]);

	/* eslint-disable */
	useEffect(() => {
		async function foo() {
			// updateLoadingHeader(true);

			const organizations = await getAPI(`/organizations`);

			setOrganizationOptions(organizations.data.map(org => {
				return {
					key   : org.id,
					text  : org.title,
					value : org.id,
				}
			}));

			let api_route = `/projects?organization_id=${current_organization_id}`;

			if(!current_organization_id) {
				updateOrganizationId(organizations.data[0].id);
				api_route = `/projects?organization_id=${organizations.data[0].id}`;
			}

			const projects = await getAPI(api_route);

			setProjectOptions(projects.data.map(project => {
				return {
					key   : project.id,
					text  : project.title,
					value : project.id,
				}
			}));

			if(!current_project_id) {
				updateProjectId(projects.data[0].id);
			}

			// updateLoadingHeader(false);
		}

		foo();
	}, [current_organization_id]);
	/* eslint-enable */

	function handleOrganizationChange(e, { value }) {
		updateOrganizationId(value);

		updateProjectId(null);
	}

	function handleProjectChange(e, { value }) {
		updateProjectId(value);
	}

	function logout() {
		clearLocalStorage();
		window.location = `/login`;
	}

	return (
		<CustomDiv>
			<TopMenu
				vertical
				style={menu_css}
			>
				<Menu.Item
					header
					name="Dashboard"
					as={NavLink}
					to="/"
					exact
				>Test Ledger</Menu.Item>

				{!!user.super_user &&
					<Menu.Item
						as={NavLink}
						name="Dashboard"
						to="/"
						exact
					>
						<span>
							<CustomIcon name="dashboard" />
							Dashboard
						</span>
					</Menu.Item>
				}

				<Menu.Item
					name="Runs"
					as={NavLink}
					to="/runs"
				>
					<span>
						<CustomIcon name="space shuttle" />
						Runs
					</span>
				</Menu.Item>

				<Menu.Item
					name="Specs"
					as={NavLink}
					to="/specs"
				>
					<span>
						<CustomIcon name="tasks" />
						Specs
					</span>
				</Menu.Item>

				<Menu.Item
					as={NavLink}
					name="Reports"
					to="/reports"
				>
					<span>
						<CustomIcon name="chart line" />
						Reports
					</span>
				</Menu.Item>

				{!!user.super_user &&
					<Menu.Item
						as={NavLink}
						name="Conditions"
						to="/conditions"
					>
						<span>
							<CustomIcon name="filter" />
							Conditions
						</span>
					</Menu.Item>
				}

				<Dropdown
					item
					trigger={<span><CustomIcon name="folder" />Projects</span>}
					onChange={handleProjectChange}
					options={project_options}
					value={current_project_id}
				/>

				{!!user.super_user &&
					<Dropdown
						item
						trigger={<span><CustomIcon name="globe" />Organizations</span>}
						onChange={handleOrganizationChange}
						options={organization_options}
						value={current_organization_id}
					/>
				}

				<Dropdown item trigger={<span><CustomIcon name="setting" />Settings</span>}>
					<Dropdown.Menu>
						<Dropdown.Item>General</Dropdown.Item>
						{!!user.admin &&
							<Dropdown.Item><CustomLink to="/admin/users">Administration</CustomLink></Dropdown.Item>
						}
						<Dropdown.Item><CustomLink to="/profile/info">Profile</CustomLink></Dropdown.Item>
						<Dropdown.Item
							onClick={logout}
						>Logout</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<BottomMenuItems>

				</BottomMenuItems>
			</TopMenu>
		</CustomDiv>
	);
}

export default SideBar;
